import type { ReactNode } from 'react';
import { Dialog } from 'radix-ui';
import { X } from 'lucide-react';
import { useLabels } from './provider';

/** A dialog with a title, an optional description and a close button. */
export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  width,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  width?: number;
}) {
  const labels = useLabels();
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="overlay" />
        <Dialog.Content className="dialog" style={width ? { width: `min(${width}px, calc(100vw - 32px))` } : undefined} aria-describedby={undefined}>
          <Dialog.Title asChild>
            <h2>{title}</h2>
          </Dialog.Title>
          {description && (
            <Dialog.Description className="muted" style={{ margin: '0 0 16px' }}>
              {description}
            </Dialog.Description>
          )}
          <Dialog.Close asChild>
            <button className="icon-btn sm dialog-close" aria-label={labels.close}>
              <X size={18} />
            </button>
          </Dialog.Close>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
